import React, { useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import MobileStepper from "@material-ui/core/MobileStepper";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import AOS from "aos";
import "aos/dist/aos.css";
import CoHa from "../../../../assets/images/hachef.png";
import BaTung from "../../../../assets/images/tungchef.png";
import Kaiser from "../../../../assets/images/kaiser.png";
const tutorialSteps = [
  {
    label: "Bếp Trưởng Hà",
    bio:
      "Chinh phục vị giác bằng nấu nướng, Bếp Trưởng Hà đã được vinh danh là một trong những đầu bếp giỏi nhất ở Royal Hotel Sài Gòn. Khi dành được uy tín tại buổi liên hoan bếp trưởng Á Âu 2017, đầu bếp Hà đã suy nghĩ và quyết định mở Bún Bò O Như, xem đây là đứa con tinh thần sau tất cả kinh nghiệm mà bà đã trải qua.",

    imgPath: CoHa,
  },
  {
    label: "Bếp Phó Tùng",
    bio:
      "Hơn 15 năm kinh nghiệm làm việc với các nhà hàng hải sản, ông may mắn gặp được Bếp Trưởng chung chí hướng và cùng mở Bún Bò O Như. Ngoài ra, Bếp Phó Tùng thích sáng chế các món mới trong thời gian nhàn rỗi như chia sẻ và trau dồi thêm kinh nghiệm nấu ăn của mình.",

    imgPath: BaTung,
  },
  {
    label: "Phụ Bếp Khang",
    bio:
      "Sau khi tốt nghiệp đại học, anh chưa hề nghĩ về việc làm bếp. Tuy nhiên, do số phận đưa đẩy, Bếp Trưởng cho anh một chân trong quán ăn O Như và cùng mọi người tạo ra các tô bún tuyệt hảo!",
    imgPath: Kaiser,
  },
];

const useStyles = makeStyles((theme) => ({
  cardStyle: {
    color: "white",
    background: "linear-gradient(270deg, #a59890, #cac2bd)",
    backgroundSize: "400% 400%",
    WebkitAnimation: "breath 3s ease infinite",
    MozAnimation: "breath 3s ease infinite",
    animation: "breath 3s ease infinite",
    padding: "1rem",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: 50,
    backgroundColor: "transparent",
    color: "white",
  },
  img: {
    height: 300,
    maxWidth: 300,
    overflow: "hidden",
    display: "block",
    width: "100%",
  },
}));

export default function TextMobileStepper() {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = tutorialSteps.length;
  useEffect(() => {
    AOS.init({});
  }, []);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Card className={classes.cardStyle} elevation="0">
      <CardContent>
        <Typography
          variant="h5"
          style={{ fontWeight: 300 }}
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          Đội ngũ
        </Typography>
        <div className={classes.root}>
          <Paper
            square
            elevation={0}
            className={classes.header}
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            <Typography>{tutorialSteps[activeStep].label}</Typography>
          </Paper>
          <img
            className={classes.img}
            src={tutorialSteps[activeStep].imgPath}
            alt={tutorialSteps[activeStep].label}
            data-aos="zoom-in"
            data-aos-duration="1000"
          />
          <Typography
            variant="body2"
            style={{ marginTop: "1rem" }}
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            {tutorialSteps[activeStep].bio}
          </Typography>
          <MobileStepper
            data-aos="fade-left"
            data-aos-duration="1000"
            style={{ backgroundColor: "transparent", color: "white" }}
            steps={maxSteps}
            position="static"
            variant="text"
            activeStep={activeStep}
            nextButton={
              <Button
                size="small"
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={handleBack}
                disabled={activeStep === 0}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
              </Button>
            }
          />
        </div>
      </CardContent>
    </Card>
  );
}
